import styled from 'styled-components';
import {fontProps} from '../Properties/Properties';

const Text = styled.p`
    ${fontProps}
`;

export default Text;